module.exports = __webpack_public_path__ + "img/user_ready_top2.bcba9413.png";